import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  gridContainer: {
    paddingTop: theme.spacing(1),
  },
}))

export default useStyles
